import { forwardRef, memo, useEffect, useState } from "react";
import { useMap } from "react-leaflet";
import { useDispatch } from "react-redux";
import { areaSelectionReducer } from "../../../../../shared/ReduxStore/Reducers/areaSelectionReducer";
import { listSelectionReducer } from "../../../../../shared/ReduxStore/Reducers/listSelectionReducer";
import { CommonConst as Consts } from "../../../../../shared/common-utilities/enums/CommonConst.jsx";
import dataStorageService from "../../../../../shared/common-utilities/services/DataStorageService";
import getSetDataService from "../../../../../shared/common-utilities/services/getSetDataService";

let service = getSetDataService();
const storageService = dataStorageService();

const RectangularSelection = memo((props) => {
  const map = useMap();
  const dispatch = useDispatch();
  map.selectArea.setControlKey(false);

  const dispatchSelection = (selectedData) => {
    let movementIds = [];
    const getListSelection = storageService.getLocalStorageData('listSelection');
    let existingListSelection = getListSelection ? JSON.parse(getListSelection) : [];

    if (!existingListSelection.movementIds) existingListSelection.movementIds = [];
    if (!existingListSelection.partialTripIds) existingListSelection.partialTripIds = [];
    if (!existingListSelection.routeIds) existingListSelection.routeIds = [];

    movementIds = selectedData.filter(x => x.isSelection && x.source === 'movements').map(x => x.id);
    existingListSelection.movementIds = movementIds.length > 0 ? _.uniq([...existingListSelection.movementIds, ...movementIds]) : existingListSelection.movementIds;

    dispatch(listSelectionReducer(existingListSelection));
    storageService.setLocalStorageData('listSelection', JSON.stringify(existingListSelection));
  };

  useEffect(() => {
    if (!map.selectArea) return;
    if (!props.enableRactangular) {
      map.selectArea.disable();
      map.off("selectarea:selected")
    } else {
      map.selectArea.enable();
      map.on("selectarea:selected", (event) => {
        map.off("selectarea:selected")
        map.selectArea.disable();
        let selectedData = [];
        let intersectingPolylines = new Set();
        const layersKeys = _.entries(map._layers).filter(x => x[1]?.options?.item != undefined).map(p => p[0]);
        const _selectedIds = []
        for (const key of layersKeys) {
          const layer = map._layers[key];

          if (layer?.options?.item) {
            const { id, selected, source, subid } = layer?.options?.item;
            if (source == Consts.Movements) {
              if (layer._latlng && event.bounds.contains(layer?._latlng)) {
                _selectedIds.push(id);
              } else if (layer._latlngs && Array.isArray(layer._latlngs)) {
                let isIntersecting = false;
                const latlngs = layer._latlngs.flat().map(latlng => map.latLngToLayerPoint(latlng));

                const corners = [event.bounds.getNorthEast(), event.bounds.getNorthWest(), event.bounds.getSouthWest(), event.bounds.getSouthEast(), event.bounds.getNorthEast()];

                const draggedLatLngs = corners.map(corner => map.latLngToLayerPoint(corner));

                for (let i = 1; i < latlngs.length; i++) {
                  const segmentStart1 = latlngs[i - 1];
                  const segmentEnd1 = latlngs[i];

                  for (let j = 1; j < draggedLatLngs.length; j++) {
                    const segmentStart2 = draggedLatLngs[j - 1];
                    const segmentEnd2 = draggedLatLngs[j];

                    if (service.routesIntersect(segmentStart1, segmentEnd1, segmentStart2, segmentEnd2)) {
                      _selectedIds.push(id);
                      isIntersecting = true;
                      intersectingPolylines.add(layer);
                      break;
                    }
                  }
                  if (isIntersecting) break;
                }

                if (!isIntersecting) {
                  if (intersectingPolylines.has(layer)) {
                    intersectingPolylines.delete(layer);
                  }
                  layer.setStyle({ color: layer?.options?.initColor });
                }
              }
            }
          }
        }

        for (const key of layersKeys) {
          const layer = map._layers[key];

          if (layer?.options?.item) {
            const { id, selected, source, subid } = layer?.options?.item;
            if (source != Consts.PartialTrips) {
              if (_.includes(_selectedIds, id)) {
                layer.options.item.selected = true;
                layer.options.selected = true;
                let newIcon = service.createCustomIcon(service.generateIconWithSelection(layer.options?.item?.actionNo, layer.options.selected), map.getZoom());
                layer?.setStyle ? layer.setStyle({ color: (layer.options.selected ? Consts.ColorSelected : layer?.options?.initColor) }) : layer?.setIcon(newIcon);
                selectedData.push({ type: 'marker', id: id, subid: subid, isSelection: layer.options.selected, source: source });
              } else {
                layer.options.item.selected = false;
                layer.options.selected = false;
                let newIcon = service.createCustomIcon(service.generateIconWithSelection(layer.options?.item?.actionNo, layer.options.selected), map.getZoom());
                // layer?.setStyle ? layer.setStyle({ color: (layer.options.selected ? Consts.ColorSelected : layer?.options?.initColor) }) : layer?.setIcon(newIcon);
                layer?.setStyle ? layer.setStyle({ color: layer?.options?.initColor }) : layer?.setIcon(newIcon);
              }
            }
          }
        }
        dispatch(areaSelectionReducer({ layersData: _.uniqBy(selectedData.filter(e => e.isSelection), 'id') }));
        dispatchSelection(selectedData.filter(e => e.isSelection))
      });
      // map.on("selectarea:start", (e) => { });
      // map.on("selectarea:toggled", (e) => { });
      // map.on("ondrop", (e) => { });
      // map.on("ondragover", (e) => { });
    }

    // restrict selection area
    const bounds = map.getBounds().pad(-0.25);

    // check restricted area on start and move
    map.selectArea.setValidate((layerPoint) => {
      return bounds.contains(this._map.layerPointToLatLng(layerPoint));
    });

    map.selectArea.setValidate();

    return () => {
      map.off('selectarea:selected');
    };
  }, [props.enableRactangular]);

  return null;
});

export default RectangularSelection;